import template from "./organization-profile.html";
import countriesTranslations from "../../../../common/translations/countries";

const OrganizationProfileComponent = {
  template: template,
  controller: class OrganizationProfileController {
    /* @ngInject */
    constructor(
      $rootScope,
      $state,
      $filter,
      Notification,
      Organization,
      OrganizationService,
      countries,
      Utils,
      LocaleService,
    ) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$filter = $filter;
      this.NotificationService = Notification;
      this.Organization = Organization;
      this.OrganizationService = OrganizationService;
      this.countries = countries;
      this.LocaleService = LocaleService;
      this.countryFilter = Utils.filterDiacriticsInsensitive(
        countriesTranslations,
        $rootScope.organization.settings.appLanguage,
      );
    }

    $onInit() {
      this.organization = this.$rootScope.organization;
      this.originalSlug = this.organization.slug;
      this.editableOrganization = angular.copy(this.organization);
      this.baseUrl = process.env.CLIENT_URL;
      this.loading = false;
    }

    async setAppLanguage(oldAppLanguage, newAppLanguage) {
      this.editableOrganization.settings.appLanguage = newAppLanguage;
      this.OrganizationService.updateOrganization(this.editableOrganization).then((organization) => {
        if (newAppLanguage === "es") this.LocaleService.setLanguage("es");
        else this.LocaleService.setLanguage("en");

        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.setAppLanguage"),
        });
        this.editableOrganization = angular.copy(this.$rootScope.organization);
        this.$state.reload();
      });
    }

    async setTimezone(oldTimezone, newTimezone) {
      this.editableOrganization.settings.timezone = newTimezone;
      this.OrganizationService.updateOrganization(this.editableOrganization).then((organization) => {
        this.LocaleService.setTimezone(newTimezone);
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.setTimezone"),
        });
        this.editableOrganization = angular.copy(this.$rootScope.organization);
        this.$state.reload();
      });
    }

    async updateSlug() {
      if (!this.editableOrganization.name) this.editableOrganization.slug = "";
      else this.editableOrganization.slug = await this.editableOrganization.suggestSlug();
      this.$rootScope.$applyAsync();
    }

    async updateFromProfile() {
      if (!this.form.$valid) return;

      this.loading = true;
      const organization = await this.OrganizationService.updateOrganization(this.editableOrganization);
      if (organization) {
        this.organization = organization;
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.organizationDataSaved"),
        });
        if (this.originalSlug !== this.organization.slug) {
          return this.$state.go("app.organization.profile", {
            organization: this.organization.slug,
          });
        }
      }
      this.loading = false;
      this.$rootScope.$applyAsync();
    }
  },
};

export default OrganizationProfileComponent;
